module.exports = __webpack_public_path__ + "img/Cherry.565a5779.png";